import { useFeatureValue } from '@growthbook/growthbook-react';

import InvoiceDetailRevamp from '../InvoiceDetailsRevamp';
import InvoiceDetail from '../InvoiceItem';

import { FEATURE_TOGGLE } from '@/constants/featuretoggle';

const InvoiceDetailsView = () => {
  const showInvoiceDetailsRevamp = useFeatureValue(
    FEATURE_TOGGLE.InvoiceDetailsRevamp,
    false
  );

  return showInvoiceDetailsRevamp ? <InvoiceDetailRevamp /> : <InvoiceDetail />;
};

export default InvoiceDetailsView;
